// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"k0-z","subtitle":"l0-z","wrapper":"m0-z","leftArrow":"n0-z","rightArrow":"o0-z"};